import React, { useEffect, useState } from "react";
import { TileLayer } from "react-leaflet";

export default function RadarLayer() {
  // cache-bust every 5 minutes so the composite stays current
  const [stamp, setStamp] = useState(() => Math.floor(Date.now() / 300000));

  useEffect(() => {
    const t = setInterval(() => setStamp(Math.floor(Date.now() / 300000)), 60000);
    return () => clearInterval(t);
  }, []);

  return (
    <TileLayer
      key={stamp}
      url={`https://mesonet.agron.iastate.edu/cache/tile.py/1.0.0/nexrad-n0q-900913/{z}/{x}/{y}.png?_=${stamp}`}
      opacity={0.7}
      zIndex={350}
      attribution="NEXRAD via IEM"
    />
  );
}
